(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["glm-form-routing"] && !Shopify.designMode) return;
  try {
    function glmRouteFocusedForms() {
    const configNode = document.getElementById('glm-form-routing');
    if (!configNode) return;
    const config = JSON.parse(configNode.textContent);
    const params = new URLSearchParams(window.location.search);
    let referral = (params.get('ref') || params.get('utm_source') || '').slice(0, 100);
    const medium = params.get('utm_medium') || '';
    if (/facebook|instagram|meta/i.test(referral) && /paid|cpc|ppc/i.test(medium)) referral += ' ad';
    try {
      if (referral) sessionStorage.setItem('glmReferral', referral);
      else referral = sessionStorage.getItem('glmReferral') || '';
    } catch {}
    const decorate = url => {
      const form = Object.values(config.forms).find(item => url.origin + url.pathname === item.url);
      if (form && referral && !url.searchParams.has(form.referral)) url.searchParams.set(form.referral, referral);
      return url.toString();
    };
    const topic = params.get('interest');
    if (/\/pages\/contact\/?$/.test(window.location.pathname) && config.topics[topic]) {
      const destination = new URL(config.topics[topic]);
      const date = config.dates[params.get('workshop_date')];
      if (topic === 'durham-workshops' && date) destination.searchParams.set(config.dateEntry, date);
      window.location.replace(decorate(destination));
      return;
    }
    document.querySelectorAll('a[href*="docs.google.com/forms/"]').forEach(anchor => {
      anchor.href = decorate(new URL(anchor.href));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', glmRouteFocusedForms, { once: true });
  else glmRouteFocusedForms();
  document.addEventListener('shopify:section:load', glmRouteFocusedForms);
  } catch(e) { console.error(e); }
})();

})();
